import { inject, Injectable } from '@angular/core';
import { LayoutService } from '@content-provider';
import type { Observable } from 'rxjs';

import { LayoutSource } from './layout-source';
import type { MarketplaceLayout } from './types';

@Injectable({ providedIn: 'root' })
export class RewardsContentLayoutSource extends LayoutSource {
  private readonly rewardsLayoutContent = inject(LayoutService);
  rewardsCenterBaseUrl = this.rewardsLayoutContent.rc_config.baseUrl;
  rewardsCenterKey = this.rewardsLayoutContent.REWARDS_CENTER_LAYOUT_KEY;

  override getLayout(): Observable<MarketplaceLayout> {
    return this.rewardsLayoutContent.getContent<MarketplaceLayout>(this.rewardsCenterBaseUrl, this.rewardsCenterKey);
  }
}
